import React from 'react'
import '../Project.css';
import Image1 from '../../Gemco-Website-Images/projects/Yas_Mall.webp';

const Project_one = () => {

  return (
    <>

      <div className='project_1_work' id="workBanner">

        <div className="container project_our_work">

          <div className="heading">
            <h1>Yas Mall — East Side</h1>
          </div>

          <hr></hr>
          <div className='project_section'>
            <div className="project_section_content">
              <h1 className="project_scope">Scope of Work</h1>
              <p>The eastern extension of Yas Mall — Abu Dhabi's largest shopping centre, located on Yas Island adjacent to Ferrari World,
                  Yas Waterworld and the Yas Marina Circuit. A major retail and entertainment destination serving both island residents and the
                  emirate's tourism ecosystem.</p>
              <p>MAIN CONTRACTOR : -</p>
              <p>MEP CONTRACTOR : Voltas</p>
              <p>GEMCO SCOPE OF WORKS : CHW and electrical works</p>
              {/* <h2 className="project_years">2014 – 2022</h2> */}
            </div>
            <div className='project_1_card'>
              <img className="project_one_image" width="500" height="300" src={Image1} alt="Project" />
            </div>
          </div>
        </div>
      </div>

    </>

  )
}

export default Project_one